'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var pTimeout = require('p-timeout');

var pWaitFor =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(condition, options) {
    var retryTimeout, promise;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _objectSpread({
              interval: 20,
              timeout: Infinity,
              leadingCheck: true
            }, options);
            promise = new Promise(function (resolve, reject) {
              var check =
              /*#__PURE__*/
              function () {
                var _ref2 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee() {
                  var value;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return condition();

                        case 3:
                          value = _context.sent;

                          if (!(typeof value !== 'boolean')) {
                            _context.next = 6;
                            break;
                          }

                          throw new TypeError('Expected condition to return a boolean');

                        case 6:
                          if (value === true) {
                            resolve();
                          } else {
                            retryTimeout = setTimeout(check, options.interval);
                          }

                          _context.next = 12;
                          break;

                        case 9:
                          _context.prev = 9;
                          _context.t0 = _context["catch"](0);
                          reject(_context.t0);

                        case 12:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this, [[0, 9]]);
                }));

                return function check() {
                  return _ref2.apply(this, arguments);
                };
              }();

              if (options.leadingCheck) {
                check();
              } else {
                retryTimeout = setTimeout(check, options.interval);
              }
            });

            if (!(options.timeout !== Infinity)) {
              _context2.next = 13;
              break;
            }

            _context2.prev = 3;
            _context2.next = 6;
            return pTimeout(promise, options.timeout);

          case 6:
            return _context2.abrupt("return", _context2.sent);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);

            if (retryTimeout) {
              clearTimeout(retryTimeout);
            }

            throw _context2.t0;

          case 13:
            return _context2.abrupt("return", promise);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[3, 9]]);
  }));

  return function pWaitFor(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = pWaitFor; // TODO: Remove this for the next major release

module.exports.default = pWaitFor;